import { render, staticRenderFns } from "./HandbookCreate.vue?vue&type=template&id=ae42924e&scoped=true"
import script from "./HandbookCreate.vue?vue&type=script&lang=js"
export * from "./HandbookCreate.vue?vue&type=script&lang=js"
import style0 from "./HandbookCreate.vue?vue&type=style&index=0&id=ae42924e&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae42924e",
  null
  
)

export default component.exports